import { useNavigate } from "react-router-dom";
import { AuthLayout, Button } from "@hiya/ui";
import infoSvg from "../../assets/icon-information.svg";
import { SUPPORT_EMAIL } from "../../auth/constants";

export function LockedPage() {
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Your account has been locked"
      icon={<img src={infoSvg} alt="" width={80} height={80} />}
      backTo="/login"
    >
      <div className="flex flex-col gap-8 items-center w-full">
        <div className="flex flex-col gap-2 items-center">
          <p className="text-base font-medium leading-[1.2] text-text-secondary text-center">
            Too many failed attempts. Your account is temporarily locked. Please try again in a few minutes, or contact your administrator at{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-brand-brown underline">
              {SUPPORT_EMAIL}
            </a>{"."}
          </p>
        </div>
        <Button onClick={() => navigate("/login")}>
          Back to Log in
        </Button>
      </div>
    </AuthLayout>
  );
}
